import { Component, inject, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core'
import { ComponentWithCopy } from '../../intefaces/interfaces'
import { AccordionModule } from 'primeng/accordion'
import { ManageHeadElements } from '../../services/manage-head-elements/manage-head-elements'
import { CallUsButton } from '../../components/call-us-button/call-us-button'
import { HeadlineLarge } from '../../components/typography/headline-large/headline-large'
import { BodyLarge } from '../../components/typography/body-large/body-large'

@Component({
	selector: 'app-faq-with-contact-card',
	imports: [CallUsButton, AccordionModule, HeadlineLarge, BodyLarge],
	templateUrl: './faq-with-contact-card.html',
	styleUrl: './faq-with-contact-card.css',
	encapsulation: ViewEncapsulation.None,
})
export class FaqWithContactCard implements OnInit, OnDestroy {
	@Input() content!: ComponentWithCopy

	private manageHeadElementService = inject(ManageHeadElements)

	ngOnInit(): void {
		const structuredFAQs = this.content?.copy?.map((faq: any) => {
			return {
				'@type': 'Question',
				name: faq.title,
				acceptedAnswer: {
					'@type': 'Answer',
					text: faq.description,
				},
			}
		})

		this.manageHeadElementService.removeScript('JsonLDFaqSchema')
		this.manageHeadElementService.addScript(structuredFAQs, 'JsonLDFaqSchema')
	}

	ngOnDestroy(): void {
		this.manageHeadElementService.removeScript('JsonLDFaqSchema')
	}
}
